import CheckRounded from '@mui/icons-material/CheckRounded';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  items: readonly string[];
  /** Labels the list for assistive technology; the heading's own id. */
  labelledBy: string;
};

/**
 * What a service covers, ticked.
 *
 * A `ul`, because the order carries nothing — unlike the steps beside it,
 * which are an `ol` for the opposite reason. The tick is decorative and
 * `aria-hidden`: a list read aloud is already a list, and "check, check,
 * check" before every item is noise.
 *
 * Two columns from `md` up. Six items in one column on a wide screen is a
 * narrow strip of text down the left of an empty band, and these items are
 * short enough that two columns do not cost legibility.
 */
export function ServiceIncludeList({ items, labelledBy }: Props) {
  return (
    <Box
      component="ul"
      aria-labelledby={labelledBy}
      sx={{
        listStyle: 'none',
        p: 0,
        m: 0,
        display: 'grid',
        gap: { xs: 3, md: 4 },
        gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
      }}
    >
      {items.map((item) => (
        <Stack key={item} component="li" direction="row" spacing={3} sx={{ alignItems: 'start' }}>
          <CheckRounded
            aria-hidden
            sx={{
              flexShrink: 0,
              mt: 0.25,
              fontSize: 18,
              p: 0.5,
              borderRadius: '50%',
              color: 'primary.main',
              bgcolor: 'rgba(var(--mui-palette-primary-mainChannel) / 0.1)',
            }}
          />
          <Typography variant="body2" color="text.secondary">
            {item}
          </Typography>
        </Stack>
      ))}
    </Box>
  );
}
